import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { pickerOptions } from "./js/config";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "city-master",
  components: {},
  mixins: [userPopMixin],
  data: function data() {
    return {
      dateTime: [],
      pickerOptions: pickerOptions,
      searchForm: {
        page: 1,
        count: 20,
        order_by: "",
        user_id: this.$route.query.userId
      },
      // 搜索表单

      dialogVisible: false,
      form: {
        phone: "",
        type: "city_master",
        level: "",
        remark: ""
      },
      btnCityMasterLoading: false,
      // 表单验证规则
      rules: {
        phone: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }, {
          min: 11,
          max: 11,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择类型",
          trigger: "change"
        }]
      },
      start: "",
      startDate: "",
      dialogTimeVisible: false,
      remarkDialogVisible: false,
      currentRemarkObj: {},
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      level: {
        0: "无",
        1: "新手",
        2: "新秀",
        3: "精英"
      },
      statusList: [{
        label: "有效房东",
        value: 2
      }, {
        label: "待观察",
        value: 3
      }, {
        label: "商家用户",
        value: 4
      }],
      paymentStatusList: [{
        label: "待结算",
        value: 0
      }, {
        label: "已结算",
        value: 1
      }
      // {
      //     label: "已扣除",
      //     value: 3,
      // },
      // {
      //     label: "待扣除",
      //     value: 4,
      // },
      ]
    };
  },
  computed: {
    userName: function userName() {
      return this.$route.query.userName;
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    // 重置表格和搜索条件
    resetTable: function resetTable() {
      var _this$$refs;
      this.searchForm = {
        page: 1,
        count: 20,
        order_by: "",
        user_id: this.$route.query.userId
      };
      // 重置表头排序样式
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.table) === null || _this$$refs === void 0 || _this$$refs.clearSort();
      this.dateTime = [];
      this.getData("search");
    },
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order) {
        // 根据排序方向确定是否添加负号
        this.searchForm.order_by = order === "ascending" ? prop : "-".concat(prop);
      } else {
        this.searchForm.order_by = "";
      }
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$page;
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.page = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCityMasterInviteRecord(_objectSpread(_objectSpread({}, _this2.searchForm), {}, {
                start_time: _this2.dateTime[0] || "",
                end_time: _this2.dateTime[1] || ""
              }));
            case 1:
              res = _context2.v;
              _this2.tableData = res.data || [];
              _this2.total = (res === null || res === void 0 || (_res$page = res.page) === null || _res$page === void 0 ? void 0 : _res$page.total) || 0;
              _this2.tableLoading = false;
              _this2.getUserListByIds(_this2.tableData, "user_id");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};